/* * 查询功能面板 * @module components/leftmenu/query * @desc 用于展示查询功能 * @author sunsi *
@date 2020年8月5日 */
<template>
  <div>
    <Row type="flex" justify="center" style="text-align: center">
      <div class="default yg" style="display: inline-block" v-on:click.stop="openShow(1)">
        <img class="check" :src="checkSrc1" />
        <div class="imgBox1">
          <img src="../../../../static/image/analysis/yg.png" />
        </div>
        <p class="text">压盖分析</p>
      </div>
      <div class="default yg" style="display: inline-block" v-on:click.stop="openShow(2)">
        <img class="check" :src="checkSrc2" />
        <div class="imgBox1">
          <img src="../../../../static/image/analysis/yg.png" />
        </div>
        <p class="text">泰森多边形</p>
      </div>
      <div class="default yg" style="display: inline-block" v-on:click.stop="openShow(3)">
        <img class="check" :src="checkSrc3" />
        <div class="imgBox1">
          <img src="../../../../static/image/analysis/yg.png" />
        </div>
        <p class="text">热力分析</p>
      </div>

      <div class="default yg" style="display: inline-block;" v-on:click.stop="openShow(4)">
        <img class="check" :src="checkSrc4" />
        <div class="imgBox1">
          <img src="../../../../static/image/analysis/yg.png" />
        </div>
        <p class="text">通用叠加</p>
      </div>
      <div class="default yg" style="display: inline-block;" v-on:click.stop="openShow(5)">
        <img class="check" :src="checkSrc5" />
        <div class="imgBox1">
          <img src="../../../../static/image/analysis/yg.png" />
        </div>
        <p class="text">邻近分析</p>
      </div>
    </Row>
    <br />
  </div>
</template>
<script>
import analysisPanel from './analysisPanel';
export default analysisPanel;
</script>
<style lang="less" scoped>
.default {
  display: inline-block;
  width: 66px;
  height: 66px;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-between;
  .check {
    position: absolute;
    top: 10px;
    left: 54px;
  }
}
.dj {
  background-image: url('../../../../static/image/analysis/btn1.png');
}
.yg {
  background-image: url('../../../../static/image/analysis/btn2.png');
  background-size: 66px 66px;
}
.imgBox1 {
  padding-top: 15px;
}
.text {
  font-size: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: -5px;
  transform: scale(0.9);
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/analysis/analysisPanel.vue